var map = {
	"./icons": 72,
	"./icons.jsx": 72,
	"./icons/add_blue.svg": 716,
	"./icons/avatar.svg": 717,
	"./icons/calendar.svg": 718,
	"./icons/chevron-back-white.svg": 719,
	"./icons/chevron-forward-white.svg": 720,
	"./icons/close-outline.svg": 721,
	"./icons/course.svg": 722,
	"./icons/eye-off-white.svg": 723,
	"./icons/eye.svg": 724,
	"./icons/generic-error.svg": 725,
	"./icons/help.svg": 726,
	"./icons/inventory.svg": 727,
	"./icons/lock.svg": 728,
	"./icons/logout.svg": 729,
	"./icons/marketing.svg": 730,
	"./icons/pos.svg": 731,
	"./icons/reports.svg": 732,
	"./icons/schedule.svg": 733,
	"./icons/search.svg": 734,
	"./icons/settings.svg": 735,
	"./icons/zoom-in.svg": 736,
	"./icons/zoom-out.svg": 737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;